import $okgportal_api from "@/shared/client/okgportal.client";
import { BaseOkgportalResponce } from "@/shared/model/api.types";
import {
  DepartmentForecastPeriodSum,
  DepartmentForecastPeriodSumDto,
  DepartmentForecastSummary,
  SaveDepartmentForecastMonthDto,
  SaveDepartmentForecastYearDto,
} from "../model/departmentForecast.types";

class DepartmentForecastApi {
  async getDepartmentForecast(departmentId: number, year: number) {
    const response = await $okgportal_api.get<BaseOkgportalResponce<DepartmentForecastSummary>>(
      `/v2/departmentForecast/${departmentId}/${year}`
    );

    return response.data;
  }

  async saveDepartmentForecastMonth(data: SaveDepartmentForecastMonthDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<DepartmentForecastSummary>>(
      "/v2/departmentForecast/month",
      data
    );

    return response.data;
  }

  async saveDepartmentForecastYear(data: SaveDepartmentForecastYearDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<DepartmentForecastSummary>>(
      "/v2/departmentForecast/year",
      data
    );

    return response.data;
  }

  async getCompanyForecastPeriodSum(data: DepartmentForecastPeriodSumDto) {
    const response = await $okgportal_api.post<BaseOkgportalResponce<DepartmentForecastPeriodSum>>(
      "/v2/departmentForecast/periodSum",
      data
    );

    return response.data;
  }
}

const departmentForecastApi = new DepartmentForecastApi();

export default departmentForecastApi;
